export default "__VITE_ASSET__BksXj4NH__"